<template>
    <div v-if="!appData.enableConfigTrial && !appData.enableConfigOption">
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.title_client_setting'"></div>
        </div>
        <div class="object-inner-table">
            <table width=100%>
                <td v-if="appData.basicContract.planType == Const.LICENSE_PLAN_SEPARATE" width=50% class="object-item" v-t="'message.info_need_purchase_option'">
                </td>
                <td v-else width=50% class="object-item" v-t="'message.info_need_purchase_enterprise_plan'">
                </td>
            </table>
        </div>
    </div>
    <div v-else>
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.title_client_setting'"></div>
            <div v-if="(selectedNode.data.type==1 & selectedNode.data.isLeaf)" class="object-titlebox-right">
                <button class="transparent-button" type="button" v-on:click="addSetting()"><img src="../../../../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.common_action_add'"></span></button>
            </div>
            <div v-if="selectedNode.data.type==2" class="object-titlebox-right">
            <!--- comment out until multiple client setting.
                <button class="cmdbutton" type="button" v-on:click="confirmDeleteClientSetting()"><img src="../assets/delete.svg"/><span class="object-command1">削除</span></button>
            -->
                <button class="transparent-button" type="button" v-on:click="checkBrowserToShowEditClientSetting()"><img src="../../../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
            </div>
        </div>
        <div v-if="selectedNode.data.type==1">
            <div class="object-inner-table">
                <table width=100%>
                    <td width=50% class="object-item">
                        <div v-if="selectedNode.data.isLeaf" v-t="'message.info_create_client_setting'"></div>
                        <div v-else v-t="'message.info_edit_client_setting'"></div>
                    </td>
                </table>
            </div>
        </div>
        <div v-if="selectedNode.data.type==2">
            <div v-if="showClientSetting" class="object-inner-table">
                <table width=100%>
                    <!--- 共通設定 --->
                    <tr class="object-titlebox" style="display: table-row">
                        <td class="object-titlebox-text" style="padding-left: 20px" v-t="'message.title_client_common'"></td>
                        <td class="object-titlebox-text" v-t="'message.title_client_value'"></td>
                        <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 起動時の自動実行 --->
                        <td width=50% class="object-item" v-t="'message.item_client_auto_start'"></td>
                        <td v-if="currentSetting.autoStart.value==0" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.autoStart.value==1" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.autoStart.enabled" active-color="#5171cb" @change="handleChangeEnabled('autoStart')"></el-switch></td>
                     </tr>
                    <tr class="setting-item-record">
                        <!--- サブボタン右 --->
                        <td width=50% class="object-item" v-t="'message.item_client_sub_button_right'"></td>
                        <td v-if="currentSetting.subButtonMode.value==0" class="object-value" v-t="'message.item_client_subButton0'"></td>
                        <td v-else-if="currentSetting.subButtonMode.value==1" class="object-value">NFC</td>
                        <td v-else-if="currentSetting.subButtonMode.value==2" class="object-value" v-t="'message.item_client_subButton2'"></td>
                        <td v-else-if="currentSetting.subButtonMode.value==3" class="object-value" v-t="'message.item_client_subButton3'"></td>
                        <td v-else-if="currentSetting.subButtonMode.value==4" class="object-value" v-t="'message.item_client_subButton4'"></td>
                        <td v-else-if="currentSetting.subButtonMode.value==5" class="object-value" v-t="'message.item_client_subButton5'"></td>
                        <td v-else-if="currentSetting.subButtonMode.value==6" class="object-value" v-t="'message.item_client_subButton6'"></td>
                        <td v-else-if="currentSetting.subButtonMode.value==7" class="object-value" v-t="'message.item_client_subButton7'"></td>
                        <td v-else-if="currentSetting.subButtonMode.value==8" class="object-value" v-t="'message.item_client_subButton8'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.subButtonMode.enabled" active-color="#5171cb" @change="handleChangeEnabled('subButtonMode')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- サブボタン左 --->
                        <td width=50% class="object-item" v-t="'message.item_client_sub_button_left'"></td>
                        <td v-if="currentSetting.subButtonLeftMode.value==0" class="object-value" v-t="'message.item_client_subButton0'"></td>
                        <td v-else-if="currentSetting.subButtonLeftMode.value==1" class="object-value">NFC</td>
                        <td v-else-if="currentSetting.subButtonLeftMode.value==2" class="object-value" v-t="'message.item_client_subButton2'"></td>
                        <td v-else-if="currentSetting.subButtonLeftMode.value==3" class="object-value" v-t="'message.item_client_subButton3'"></td>
                        <td v-else-if="currentSetting.subButtonLeftMode.value==4" class="object-value" v-t="'message.item_client_subButton4'"></td>
                        <td v-else-if="currentSetting.subButtonLeftMode.value==5" class="object-value" v-t="'message.item_client_subButton5'"></td>
                        <td v-else-if="currentSetting.subButtonLeftMode.value==6" class="object-value" v-t="'message.item_client_subButton6'"></td>
                        <td v-else-if="currentSetting.subButtonLeftMode.value==7" class="object-value" v-t="'message.item_client_subButton7'"></td>
                        <td v-else-if="currentSetting.subButtonLeftMode.value==8" class="object-value" v-t="'message.item_client_subButton8'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.subButtonLeftMode.enabled" active-color="#5171cb" @change="handleChangeEnabled('subButtonLeftMode')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- カスタムURLスキーム --->
                        <td width=50% class="object-item" v-t="'message.item_client_url_scheme_iOS'"></td>
                        <td v-if="currentSetting.customURL.value!=null" class="object-value">{{ currentSetting.customURL.value }}</td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.customURL.enabled" active-color="#5171cb" @change="handleChangeEnabled('customURL')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- カスタムURLスキーム（Android） --->
                        <td width=50% class="object-item" v-t="'message.item_client_url_scheme_android'"></td>
                        <td v-if="currentSetting.linkPackageName.value!=null" class="object-value" style="padding-top: 10px;padding-bottom: 10px;">
                            <span v-t="'message.item_client_url_scheme_package'"></span>：{{ currentSetting.linkPackageName.value }}<br>
                            <span v-t="'message.item_client_url_scheme_class'"></span>：{{ currentSetting.linkClassName.value }}
                        </td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.linkPackageName.enabled" active-color="#5171cb" @change="handleChangeEnabled('linkPackageName')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- バックグラウンドモード(iOSのみ） --->
                        <td width=50% class="object-item" v-t="'message.item_client_ios_audio_mode'"></td>
                        <td v-if="currentSetting.iOSAudioMode.value==0" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.iOSAudioMode.value==1" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.iOSAudioMode.enabled" active-color="#5171cb" @change="handleChangeEnabled('iOSAudioMode')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 画面をスリープにしない(Androidのみ） --->
                        <td width=50% class="object-item" v-t="'message.item_client_stay_awake'"></td>
                        <td v-if="currentSetting.stayAwake.value==0" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.stayAwake.value==1" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.stayAwake.enabled" active-color="#5171cb" @change="handleChangeEnabled('stayAwake')"></el-switch></td>
                    </tr>
                    <tr v-for="(fixedPhraseItemName, fixedPhraseIndex) in fixedPhraseItemList" class="setting-item-record">
                        <!--- 定型文タイトル / 定型文 --->
                        <td v-if="(fixedPhraseIndex % 2) === 0" width=50% class="object-item" v-t="{ path: 'message.item_client_fixPhraseTitle', args: { number: Math.floor(fixedPhraseIndex/2) + 1 } }"></td>
                        <td v-else width=50% class="object-item" v-t="{ path: 'message.item_client_fixPhrase', args: { number: Math.floor(fixedPhraseIndex/2) + 1 } }"></td>
                        <td v-if="currentSetting[fixedPhraseItemName].value!=null" class="object-value" style="word-break: break-all">
                            <template v-if="(fixedPhraseIndex % 2) === 0">
                                {{ currentSetting[fixedPhraseItemName].value }}
                            </template>
                            <template v-else>
                                <ClientSettingFixedPhrase :fixedPhraseList="currentSetting[fixedPhraseItemName].value"></ClientSettingFixedPhrase>
                            </template>
                        </td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting[fixedPhraseItemName].enabled" active-color="#5171cb" @change="handleChangeEnabled(fixedPhraseItemName)"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- Wi-Fi/モバイル通信の優先設定（Android） --->
                        <td width=50% class="object-item" v-t="'message.item_client_preferred_network_android'"></td>
                        <td v-if="currentSetting.preferredNetworkAndroid.value==0" class="object-value" v-t="'message.item_client_preferred_network_android_wifi'"></td>
                        <td v-else-if="currentSetting.preferredNetworkAndroid.value==1" class="object-value" v-t="'message.item_client_preferred_network_android_mobile'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.preferredNetworkAndroid.enabled" active-color="#5171cb" @change="handleChangeEnabled('preferredNetworkAndroid')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- Wi-Fi/モバイル通信の優先設定（iOS） --->
                        <td width=50% class="object-item" v-t="'message.item_client_preferred_network_ios'"></td>
                        <td v-if="currentSetting.preferredNetworkIOS.value==0" class="object-value" v-t="'message.item_client_preferred_network_ios_wifi'"></td>
                        <td v-else-if="currentSetting.preferredNetworkIOS.value==1" class="object-value" v-t="'message.item_client_preferred_network_ios_mobile'"></td>
                        <td v-else-if="currentSetting.preferredNetworkIOS.value==2" class="object-value" v-t="'message.item_client_preferred_network_ios_wifi_with_mobile'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.preferredNetworkIOS.enabled" active-color="#5171cb" @change="handleChangeEnabled('preferredNetworkIOS')"></el-switch></td>
                    </tr>
                    <!--- トーク設定 --->
                    <tr class="object-titlebox" style="display: table-row">
                        <td class="object-titlebox-text" style="padding-left: 20px" v-t="'message.title_client_talk'"></td>
                        <td class="object-titlebox-text" v-t="'message.title_client_value'"></td>
                        <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 画面ボタンの動作 --->
                        <td width=50% class="object-item" v-t="'message.item_client_main_button'"></td>
                        <td v-if="currentSetting.buttonMode.value==0" class="object-value" v-t="'message.value_hold'"></td>
                        <td v-else-if="currentSetting.buttonMode.value==1" class="object-value" v-t="'message.value_toggle'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.buttonMode.enabled" active-color="#5171cb" @change="handleChangeEnabled('buttonMode')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 外部ボタンの動作 --->
                        <td width=50% class="object-item" v-t="'message.item_client_ble_button'"></td>
                        <td v-if="currentSetting.bleButtonMode.value==0" class="object-value" v-t="'message.value_hold'"></td>
                        <td v-else-if="currentSetting.bleButtonMode.value==1" class="object-value" v-t="'message.value_toggle'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.bleButtonMode.enabled" active-color="#5171cb" @change="handleChangeEnabled('bleButtonMode')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- ミニトークボタンの動作 --->
                        <td width=50% class="object-item" v-t="'message.item_client_mini_talk_button'"></td>
                        <td v-if="currentSetting.miniTalkButtonMode.value==0" class="object-value" v-t="'message.value_hold'"></td>
                        <td v-else-if="currentSetting.miniTalkButtonMode.value==1" class="object-value" v-t="'message.value_toggle'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.miniTalkButtonMode.enabled" active-color="#5171cb" @change="handleChangeEnabled('miniTalkButtonMode')"></el-switch></td>
                    </tr>
                    <!--- Face to talk --->
                    <tr class="setting-item-record">
                        <td width=50% class="object-item" v-t="'message.item_client_face_to_talk'"></td>
                        <td v-if="currentSetting.faceToTalkMode.value==0" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.faceToTalkMode.value==1" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.faceToTalkMode.enabled" active-color="#5171cb" @change="handleChangeEnabled('faceToTalkMode')"></el-switch></td>
                    </tr>
                    <!--- エコーモード --->
                    <tr class="setting-item-record">
                        <td width=50% class="object-item" v-t="'message.item_client_echo_mode'"></td>
                        <td v-if="currentSetting.echo.value==0" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.echo.value==1" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.echo.enabled" active-color="#5171cb" @change="handleChangeEnabled('echo')"></el-switch></td>
                    </tr>
                    <!--- VOX --->
                    <tr class="setting-item-record">
                        <td width=50% class="object-item" v-t="'message.item_client_vox'"></td>
                        <td v-if="currentSetting.vox.value==0" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.vox.value==1" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.vox.enabled" active-color="#5171cb" @change="handleChangeEnabled('vox')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- マイクを常時オンにする --->
                        <td width=50% class="object-item" v-t="'message.item_client_background_mic'"></td>
                        <td v-if="currentSetting.backgroundMic.value==0" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.backgroundMic.value==1" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.backgroundMic.enabled" active-color="#5171cb" @change="handleChangeEnabled('backgroundMic')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 音声処理をオンにする --->
                        <td width=50% class="object-item" v-t="'message.item_client_voice_processing'"></td>
                        <td v-if="currentSetting.voiceProcessing.value==0" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.voiceProcessing.value==1" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.voiceProcessing.enabled" active-color="#5171cb" @change="handleChangeEnabled('voiceProcessing')"></el-switch></td>
                    </tr>
                    <!--- チャット設定 --->
                    <tr class="object-titlebox" style="display: table-row">
                        <td class="object-titlebox-text" style="padding-left: 20px" v-t="'message.title_client_chat'"></td>
                        <td class="object-titlebox-text" v-t="'message.title_client_value'"></td>
                        <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 翻訳結果の自動読み上げ --->
                        <td width=50% class="object-item" v-t="'message.item_client_speak'"></td>
                        <td v-if="currentSetting.autoSpeak.value=='0'" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.autoSpeak.value=='1'" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.autoSpeak.enabled" active-color="#5171cb" @change="handleChangeEnabled('autoSpeak')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- テキスト受信時の自動読み上げ --->
                        <td width=50% class="object-item" v-t="'message.item_client_speakText'"></td>
                        <td v-if="currentSetting.autoSpeakText.value=='0'" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.autoSpeakText.value=='1'" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.autoSpeakText.enabled" active-color="#5171cb" @change="handleChangeEnabled('autoSpeakText')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 読み上げ対象のグループ --->
                        <td width=50% class="object-item" v-t="'message.item_client_chatSubscribeMode'"></td>
                        <td v-if="currentSetting.chatSubscribeMode.value=='0'" class="object-value" v-t="'message.item_client_chatSubscribe_talk'"></td>
                        <td v-else-if="currentSetting.chatSubscribeMode.value=='1'" class="object-value" v-t="'message.item_client_chatSubscribe_both'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.chatSubscribeMode.enabled" active-color="#5171cb" @change="handleChangeEnabled('chatSubscribeMode')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 撮影時に送信画面を表示する --->
                        <td width=50% class="object-item" v-t="'message.item_client_camera_preview'"></td>
                        <td v-if="currentSetting.cameraPreview.value=='0'" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.cameraPreview.value=='1'" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.cameraPreview.enabled" active-color="#5171cb" @change="handleChangeEnabled('cameraPreview')"></el-switch></td>
                    </tr>
                    <!--- ライブキャスト設定 --->
                    <tr class="object-titlebox" style="display: table-row">
                        <td class="object-titlebox-text" style="padding-left: 20px" v-t="'message.title_client_video'"></td>
                        <td class="object-titlebox-text" v-t="'message.title_client_value'"></td>
                        <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 解像度とフレームレート --->
                        <td width=50% class="object-item" v-t="'message.item_client_resolution'"></td>
                        <td v-if="currentSetting.resolution.value==0" class="object-value" v-t="'message.item_cilent_resolution_option1'"></td>
                        <td v-else-if="currentSetting.resolution.value==1" class="object-value" v-t="'message.item_cilent_resolution_option2'"></td>
                        <td v-else-if="currentSetting.resolution.value==2" class="object-value" v-t="'message.item_cilent_resolution_option3'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.resolution.enabled" active-color="#5171cb" @change="handleChangeEnabled('resolution')"></el-switch></td>
                    </tr>
                    <!--- マップ設定 --->
                    <tr class="object-titlebox" style="display: table-row">
                        <td class="object-titlebox-text" style="padding-left: 20px" v-t="'message.title_client_map'"></td>
                        <td class="object-titlebox-text" v-t="'message.title_client_value'"></td>
                        <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 現在地の取得 --->
                        <td width=50% class="object-item" v-t="'message.item_client_location_acquire'"></td>
                        <td v-if="currentSetting.locationAcquire.value=='0'" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.locationAcquire.value=='1'" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.locationAcquire.enabled" active-color="#5171cb" @change="handleChangeEnabled('locationAcquire')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 位置情報の送信 --->
                        <td width=50% class="object-item" v-t="'message.item_client_location'"></td>
                        <td v-if="currentSetting.locationUpload.value=='0'" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.locationUpload.value=='1'" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.locationUpload.enabled" active-color="#5171cb" @change="handleChangeEnabled('locationUpload')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 使用するマップコンポーネント --->
                        <td width=50% class="object-item" v-t="'message.item_client_map_mode'"></td>
                        <td v-if="currentSetting.mapMode.value=='0'" class="object-value" v-t="'message.item_map_apple'"></td>
                        <td v-else-if="currentSetting.mapMode.value=='1'" class="object-value" v-t="'message.item_map_google'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.mapMode.enabled" active-color="#5171cb" @change="handleChangeEnabled('mapMode')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- マップのタイプ --->
                        <td width=50% class="object-item" v-t="'message.item_client_map_type'"></td>
                        <td v-if="currentSetting.mapType.value=='0'" class="object-value" v-t="'message.item_normal'"></td>
                        <td v-else-if="currentSetting.mapType.value=='1'" class="object-value" v-t="'message.item_map_satellite'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.mapType.enabled" active-color="#5171cb" @change="handleChangeEnabled('mapType')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 位置情報の送信間隔 --->
                        <td width=50% class="object-item" v-t="'message.item_client_location_interval'"></td>
                        <td v-if="currentSetting.locationInterval.value!=null" class="object-value" v-t="{ path: 'message.item_client_second', args: { time: currentSetting.locationInterval.value } }"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.locationInterval.enabled" active-color="#5171cb" @change="handleChangeEnabled('locationInterval')"></el-switch></td>
                    </tr>
                    <!--- ボリューム設定 --->
                    <tr class="object-titlebox" style="display: table-row">
                        <td class="object-titlebox-text" style="padding-left: 20px" v-t="'message.title_client_sound'"></td>
                        <td class="object-titlebox-text" v-t="'message.title_client_value'"></td>
                        <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 再接続時のアラート音のボリューム --->
                        <td width=50% class="object-item" v-t="'message.item_client_reconnect_alert'"></td>
                        <td class="object-value">
                            <el-slider v-model="currentSetting.reconnectSoundVolume.value" disabled></el-slider>
                        </td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.reconnectSoundVolume.enabled" active-color="#5171cb" @change="handleChangeEnabled('reconnectSoundVolume')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 音量のボリューム --->
                        <td width=50% class="object-item" v-t="'message.item_client_voice_level'"></td>
                        <td class="object-value">
                            <el-slider v-model="currentSetting.voiceVolume.value" max="200" disabled></el-slider>
                        </td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.voiceVolume.enabled" active-color="#5171cb" @change="handleChangeEnabled('voiceVolume')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 電話中の音声のボリューム --->
                        <td width=50% class="object-item" v-t="'message.item_client_voice_level_during_call'"></td>
                        <td class="object-value">
                            <el-slider v-model="currentSetting.voiceOffHookVolume.value" max="200" disabled></el-slider>
                        </td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.voiceOffHookVolume.enabled" active-color="#5171cb" @change="handleChangeEnabled('voiceOffHookVolume')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- マイクのボリューム --->
                        <td width=50% class="object-item" v-t="'message.item_client_mic_level'"></td>
                        <td class="object-value">
                            <el-slider v-model="currentSetting.micVolume.value" max="200" disabled></el-slider>
                        </td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.micVolume.enabled" active-color="#5171cb" @change="handleChangeEnabled('micVolume')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 操作音のボリューム --->
                        <td width=50% class="object-item" v-t="'message.item_client_operation_sound'"></td>
                        <td class="object-value">
                            <el-slider v-model="currentSetting.reactionSoundVolume.value" disabled></el-slider>
                        </td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.reactionSoundVolume.enabled" active-color="#5171cb" @change="handleChangeEnabled('reactionSoundVolume')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 受信時のビープ音のボリューム --->
                        <td width=50% class="object-item" v-t="'message.item_client_beep_level'"></td>
                        <td class="object-value">
                            <el-slider v-model="currentSetting.receiveBeepVolume.value" disabled></el-slider>
                        </td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.receiveBeepVolume.enabled" active-color="#5171cb" @change="handleChangeEnabled('receiveBeepVolume')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 効果音のボリューム --->
                        <td width=50% class="object-item" v-t="'message.item_client_effect_level'"></td>
                        <td class="object-value">
                            <el-slider v-model="currentSetting.effectSoundVolume.value" disabled></el-slider>
                        </td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.effectSoundVolume.enabled" active-color="#5171cb" @change="handleChangeEnabled('effectSoundVolume')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 緊急起動時のアラート音のボリューム --->
                        <td width=50% class="object-item" v-t="'message.item_client_forcedActivation_alert'"></td>
                        <td class="object-value">
                            <el-slider v-model="currentSetting.alertSoundVolume.value" disabled></el-slider>
                        </td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.alertSoundVolume.enabled" active-color="#5171cb" @change="handleChangeEnabled('alertSoundVolume')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- エコーモード --->
                        <td width=50% class="object-item" v-t="'message.item_client_echo_mode_volume'"></td>
                        <td class="object-value">
                            <el-slider v-model="currentSetting.echoSoundVolume.value" disabled></el-slider>
                        </td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.echoSoundVolume.enabled" active-color="#5171cb" @change="handleChangeEnabled('echoSoundVolume')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 発話中アラート音 --->
                        <td width=50% class="object-item" v-t="'message.item_client_inSpeechAlert_volume'"></td>
                        <td class="object-value">
                            <el-slider v-model="currentSetting.inSpeechAlertVolume.value" disabled></el-slider>
                        </td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.inSpeechAlertVolume.enabled" active-color="#5171cb" @change="handleChangeEnabled('inSpeechAlertVolume')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- 重複時の音量 --->
                        <td width=50% class="object-item" v-t="'message.item_client_voice_level_during_duplicate'"></td>
                        <td v-if="currentSetting.duplicateVolume.value" class="object-value" v-t="{ path: 'message.item_client_duplicate_volume_option', args: { value: currentSetting.duplicateVolume.value } }"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.duplicateVolume.enabled" active-color="#5171cb" @change="handleChangeEnabled('duplicateVolume')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!---ボリュームロックを無効にする --->
                        <td width=50% class="object-item" v-t="'message.item_client_disable_volume_lock'"></td>
                        <td v-if="currentSetting.lockedVolume.value===-1" class="object-value" v-t="'message.value_disable_mute'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.lockedVolume.enabled" active-color="#5171cb" @change="handleChangeEnabled('lockedVolume')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!---マスターミュートを無効にする --->
                        <td width=50% class="object-item" v-t="'message.item_client_disable_master_mute'"></td>
                        <td v-if="currentSetting.masterSound.value=='1'" class="object-value" v-t="'message.value_disable_mute'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.masterSound.enabled" active-color="#5171cb" @change="handleChangeEnabled('masterSound')"></el-switch></td>
                    </tr>
                    <tr class="object-titlebox" style="display: table-row">
                        <td class="object-titlebox-text" style="padding-left: 20px" v-t="'message.title_client_notification'"></td>
                        <td class="object-titlebox-text" v-t="'message.title_client_value'"></td>
                        <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                    </tr>
                    <!--- 通知設定 --->
                    <tr class="setting-item-record">
                        <!---音声通知 --->
                        <td width=50% class="object-item" v-t="'message.item_client_voice_notification'"></td>
                        <td v-if="currentSetting.voiceNotification.value===0" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.voiceNotification.value===1" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.voiceNotification.enabled" active-color="#5171cb" @change="handleChangeEnabled('voiceNotification')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!---フォアグラウンド時に通知を表示 --->
                        <td width=50% class="object-item" v-t="'message.item_client_notify_in_foreground'"></td>
                        <td v-if="currentSetting.notifyInForeground.value=='0'" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.notifyInForeground.value=='1'" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.notifyInForeground.enabled" active-color="#5171cb" @change="handleChangeEnabled('notifyInForeground')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!---音声受信時の通知 --->
                        <td width=50% class="object-item" v-t="'message.item_client_talk_notification'"></td>
                        <td v-if="currentSetting.onNewTalker.value=='0'" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.onNewTalker.value=='1'" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.onNewTalker.enabled" active-color="#5171cb" @change="handleChangeEnabled('onNewTalker')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!---音声受信時の振動 --->
                        <td width=50% class="object-item" v-t="'message.item_client_talk_vibe'"></td>
                        <td v-if="currentSetting.vibeOnNewTalker.value=='0'" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.vibeOnNewTalker.value=='1'" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.vibeOnNewTalker.enabled" active-color="#5171cb" @change="handleChangeEnabled('vibeOnNewTalker')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!---音声受信時の振動パターン --->
                        <td width=50% class="object-item" v-t="'message.item_client_talk_vibe_pattern'"></td>
                        <td v-if="currentSetting.vibeTypeOnNewTalker.value!=null" class="object-value" v-t="{ path: 'message.item_client_vibrate_type', args: { No: currentSetting.vibeTypeOnNewTalker.value+1 } }"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.vibeTypeOnNewTalker.enabled" active-color="#5171cb" @change="handleChangeEnabled('vibeTypeOnNewTalker')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!---メッセージ受信時の通知 --->
                        <td width=50% class="object-item" v-t="'message.item_client_msg_notification'"></td>
                        <td v-if="currentSetting.onNewMessage.value=='0'" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.onNewMessage.value=='1'" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.onNewMessage.enabled" active-color="#5171cb" @change="handleChangeEnabled('onNewMessage')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!---メッセージ受信時の振動 --->
                        <td width=50% class="object-item" v-t="'message.item_client_msg_vibe'"></td>
                        <td v-if="currentSetting.vibeOnNewMessage.value=='0'" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.vibeOnNewMessage.value=='1'" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.vibeOnNewMessage.enabled" active-color="#5171cb" @change="handleChangeEnabled('vibeOnNewMessage')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!---メッセージ受信時の振動パターン --->
                        <td width=50% class="object-item" v-t="'message.item_client_msg_vibe_pattern'"></td>
                        <td v-if="currentSetting.vibeTypeOnNewMessage.value!=null" class="object-value" v-t="{ path: 'message.item_client_vibrate_type', args: { No: currentSetting.vibeTypeOnNewMessage.value+1 } }"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.vibeTypeOnNewMessage.enabled" active-color="#5171cb" @change="handleChangeEnabled('vibeTypeOnNewMessage')"></el-switch></td>
                    </tr>
                    <!--- Bluetoothアラート設定 --->
                    <tr class="object-titlebox" style="display: table-row">
                        <td class="object-titlebox-text" style="padding-left: 20px" v-t="'message.title_client_bluetooth_alert'"></td>
                        <td class="object-titlebox-text" v-t="'message.title_client_value'"></td>
                        <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- Bluetooth切断時のアラート --->
                        <td width=50% class="object-item" v-t="'message.item_client_bluetooth_alert'"></td>
                        <td v-if="currentSetting.bluetoothAlert.value===0" class="object-value" v-t="'message.value_off'"></td>
                        <td v-else-if="currentSetting.bluetoothAlert.value===1" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.bluetoothAlert.enabled" active-color="#5171cb" @change="handleChangeEnabled('bluetoothAlert')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!---アラートの終了時間 --->
                        <td width=50% class="object-item" v-t="'message.item_client_bluetooth_alert_period_time'"></td>
                        <td v-if="currentSetting.alertPeriod.value!=null" class="object-value">
                            <span  v-t="{ path: 'message.item_client_second', args: { time: currentSetting.alertPeriod.value } }"></span>
                        </td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.alertPeriod.enabled" active-color="#5171cb" @change="handleChangeEnabled('alertPeriod')"></el-switch></td>
                    </tr>
                    <tr class="setting-item-record">
                        <!--- アラートのタイプ設定 --->
                        <td width=50% class="object-item" v-t="'message.item_client_bluetooth_alert_type'"></td>
                        <td v-if="currentSetting.alertOption.value!=null" class="object-value" style="padding-top: 10px;padding-bottom: 10px;">
                            <span style="display: inline-block; width: 120px" v-t="'message.item_fixed_phrase_sound'"></span>：
                            <span v-if="(currentSetting.alertOption.value&CONSTANT.BLUETOOTH_ALERT_SOUND)===CONSTANT.BLUETOOTH_ALERT_SOUND" v-t="'message.value_on'"></span>
                            <span v-else v-t="'message.value_off'"></span>
                            <br>
                            <span style="display: inline-block; width: 120px" v-t="'message.item_fixed_phrase_vibration'"></span>：
                            <span v-if="(currentSetting.alertOption.value&CONSTANT.BLUETOOTH_ALERT_VIB)===CONSTANT.BLUETOOTH_ALERT_VIB" v-t="'message.value_on'"></span>
                            <span v-else v-t="'message.value_off'"></span>
                            <br>
                        </td>
                        <td v-else class="object-value">-</td>
                        <td class="setting-switch"><el-switch v-model="currentSetting.alertOption.enabled" active-color="#5171cb" @change="handleChangeEnabled('alertOption')"></el-switch></td>
                    </tr>

                </table>
            </div>
        </div>
        <editclientsetting v-if="showEditClientSetting" :orgSettingName="selectedNode.data.settingName" :clientSettingInfo="clientSettingInfo" :fixedPhraseItem="fixedPhraseItem" :fixedPhraseItemList="fixedPhraseItemList" @save="modifyClientSetting" @cancel="showEditClientSetting=false"></editclientsetting>
        <deleteclientsetting v-if="showDeleteClientSetting" :confirmInfo="confirmInfo" @delete="deleteCientSetting" @cancel="showDeleteUser=false"></deleteclientsetting>
    </div>
</template>

<script>
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import DeleteObject from "../../../DeleteObject.vue";
import EditClientSetting from "@/components/pc/setting/clientsetting/ClientSettingEdit.vue";
import ClientSettingFixedPhrase from "@/components/pc/setting/clientsetting/ClientSettingFixedPhrase";

export default {
    components: {
        editclientsetting: EditClientSetting,
        ClientSettingFixedPhrase: ClientSettingFixedPhrase,
        deleteclientsetting: DeleteObject
    },

    props: {
        selectedNode: {},
        appData: {},
    },

    data() {
        return {
            CONSTANT: {
                FIXED_PHRASE_CATEGORY_TEXT: constants.FIXED_PHRASE_CATEGORY_TEXT,
                FIXED_PHRASE_CATEGORY_SOUND: constants.FIXED_PHRASE_CATEGORY_SOUND,
                FIXED_PHRASE_CATEGORY_MELODY: constants.FIXED_PHRASE_CATEGORY_MELODY,
                BLUETOOTH_ALERT_SOUND: constants.BLUETOOTH_ALERT_SOUND,
                BLUETOOTH_ALERT_VIB: constants.BLUETOOTH_ALERT_VIB,
            },
            showClientSetting: false,
            showEditClientSetting: false,
            showDeleteClientSetting: false,
            clientSettingInfo: [],
            confirmInfo: {
                objectName: null,
                objectTitle: null
            },
            defaultSetting: {
                Common: {},
                Talk: {},
                Chat: {},
                Video: {},
                Volume: {},
                Notification: {}
            },
            currentSetting: {
                autoStart:              { category: "Common"       , value: null ,enabled : false },
                subButtonMode:          { category: "Common"       , value: null ,enabled : false },
                subButtonLeftMode:      { category: "Common"       , value: null ,enabled : false },
                customURL:              { category: "Common"       , value: null ,enabled : false },
                locationAcquire:        { category: "Common"       , value: null ,enabled : false },
                locationUpload:         { category: "Common"       , value: null ,enabled : false },
                locationInterval:       { category: "Common"       , value: null ,enabled : false },
                bluetoothAlert:         { category: "Common"       , value: null ,enabled : false },
                alertPeriod:            { category: "Common"       , value: null ,enabled : false },
                alertOption:            { category: "Common"       , value: null ,enabled : false },
                iOSAudioMode:           { category: "Common"       , value: null ,enabled : false },
                mapMode:                { category: "Common"       , value: null ,enabled : false },
                mapType:                { category: "Common"       , value: null ,enabled : false },
                stayAwake:              { category: "Common"       , value: null ,enabled : false },
                linkPackageName:        { category: "Common"       , value: null ,enabled : false },
                linkClassName:          { category: "Common"       , value: null ,enabled : false },
                fixedPhrase1:           { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle1:      { category: "Common"       , value: null ,enabled : false },
                fixedPhrase2:           { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle2:      { category: "Common"       , value: null ,enabled : false },
                fixedPhrase3:           { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle3:      { category: "Common"       , value: null ,enabled : false },
                fixedPhrase4:           { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle4:      { category: "Common"       , value: null ,enabled : false },
                fixedPhrase5:           { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle5:      { category: "Common"       , value: null ,enabled : false },
                fixedPhrase6:           { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle6:      { category: "Common"       , value: null ,enabled : false },
                fixedPhrase7:           { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle7:      { category: "Common"       , value: null ,enabled : false },
                fixedPhrase8:           { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle8:      { category: "Common"       , value: null ,enabled : false },
                fixedPhrase9:           { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle9:      { category: "Common"       , value: null ,enabled : false },
                fixedPhrase10:          { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle10:     { category: "Common"       , value: null ,enabled : false },
                fixedPhrase11:          { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle11:     { category: "Common"       , value: null ,enabled : false },
                fixedPhrase12:          { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle12:     { category: "Common"       , value: null ,enabled : false },
                fixedPhrase13:          { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle13:     { category: "Common"       , value: null ,enabled : false },
                fixedPhrase14:          { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle14:     { category: "Common"       , value: null ,enabled : false },
                fixedPhrase15:          { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle15:     { category: "Common"       , value: null ,enabled : false },
                fixedPhrase16:          { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle16:     { category: "Common"       , value: null ,enabled : false },
                fixedPhrase17:          { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle17:     { category: "Common"       , value: null ,enabled : false },
                fixedPhrase18:          { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle18:     { category: "Common"       , value: null ,enabled : false },
                fixedPhrase19:          { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle19:     { category: "Common"       , value: null ,enabled : false },
                fixedPhrase20:          { category: "Common"       , value: null ,enabled : false },
                fixedPhraseTitle20:     { category: "Common"       , value: null ,enabled : false },
                preferredNetworkAndroid:{ category: "Common"       , value: null ,enabled : false },
                preferredNetworkIOS:    { category: "Common"       , value: null ,enabled : false },
                buttonMode:             { category: "Talk"         , value: null ,enabled : false },
                bleButtonMode:          { category: "Talk"         , value: null ,enabled : false },
                faceToTalkMode:         { category: "Talk"         , value: null ,enabled : false },
                vox:                    { category: "Talk"         , value: null ,enabled : false },
                backgroundMic:          { category: "Talk"         , value: null ,enabled : false },
                echo:                   { category: "Talk"         , value: null ,enabled : false },
                miniTalkButtonMode:     { category: "Talk"         , value: null ,enabled : false },
                voiceProcessing:        { category: "Talk"         , value: null ,enabled : false },
                chatSubscribeMode:      { category: "Chat"         , value: null ,enabled : false },
                autoSpeak:              { category: "Chat"         , value: null ,enabled : false },
                autoSpeakText:          { category: "Chat"         , value: null ,enabled : false },
                cameraPreview:          { category: "Chat"         , value: null ,enabled : false },
                resolution:             { category: "Video"        , value: null ,enabled : false },
                reconnectSoundVolume:   { category: "Volume"       , value: null ,enabled : false },
                alertSoundVolume :      { category: "Volume"       , value: null ,enabled : false },
                reactionSoundVolume:    { category: "Volume"       , value: null ,enabled : false },
                receiveBeepVolume:      { category: "Volume"       , value: null ,enabled : false },
                voiceVolume:            { category: "Volume"       , value: null ,enabled : false },
                duplicateVolume:        { category: "Volume"       , value: null ,enabled : false },
                voiceOffHookVolume:     { category: "Volume"       , value: null ,enabled : false },
                micVolume:              { category: "Volume"       , value: null ,enabled : false },
                effectSoundVolume:      { category: "Volume"       , value: null ,enabled : false },
                echoSoundVolume:        { category: "Volume"       , value: null ,enabled : false },
                inSpeechAlertVolume:    { category: "Volume"       , value: null ,enabled : false },
                lockedVolume:           { category: "Volume"       , value: null ,enabled : false },
                masterSound:            { category: "Volume"       , value: null ,enabled : false },
                notifyInForeground:     { category: "Notification" , value: null ,enabled : false },
                onNewTalker:            { category: "Notification" , value: null ,enabled : false },
                onNewMessage:           { category: "Notification" , value: null ,enabled : false },
                vibeOnNewTalker:        { category: "Notification" , value: null ,enabled : false },
                vibeOnNewMessage:       { category: "Notification" , value: null ,enabled : false },
                vibeTypeOnNewTalker:    { category: "Notification" , value: null ,enabled : false },
                vibeTypeOnNewMessage:   { category: "Notification" , value: null ,enabled : false },
                voiceNotification:      { category: "Notification" , value: null ,enabled : false },
            },
            Const: {
                LICENSE_PLAN_SEPARATE: constants.LICENSE_PLAN_SEPARATE
            },
            fixedPhraseCategoryList : [
                { value: constants.FIXED_PHRASE_CATEGORY_TEXT, messageId: "item_fixed_phrase_text" },
                { value: constants.FIXED_PHRASE_CATEGORY_SOUND, messageId: "item_fixed_phrase_sound" },
                { value: constants.FIXED_PHRASE_CATEGORY_MELODY, messageId: "item_fixed_phrase_melody" },
            ],
            soundTypeList : [
                { value:1, messageId: "item_sound1" },
                { value:2, messageId: "item_sound2" },
            ],
            fixedPhraseItem: {
                category: [],
                soundType: []
            },
            fixedPhraseItemList: [
                "fixedPhraseTitle1", "fixedPhrase1", "fixedPhraseTitle2", "fixedPhrase2", "fixedPhraseTitle3", "fixedPhrase3", "fixedPhraseTitle4", "fixedPhrase4", "fixedPhraseTitle5", "fixedPhrase5",
                "fixedPhraseTitle6", "fixedPhrase6", "fixedPhraseTitle7", "fixedPhrase7", "fixedPhraseTitle8", "fixedPhrase8", "fixedPhraseTitle9", "fixedPhrase9", "fixedPhraseTitle10", "fixedPhrase10",
                "fixedPhraseTitle11", "fixedPhrase11", "fixedPhraseTitle12", "fixedPhrase12", "fixedPhraseTitle13", "fixedPhrase13", "fixedPhraseTitle14", "fixedPhrase14", "fixedPhraseTitle15", "fixedPhrase15",
                "fixedPhraseTitle16", "fixedPhrase16", "fixedPhraseTitle17", "fixedPhrase17", "fixedPhraseTitle18", "fixedPhrase18", "fixedPhraseTitle19", "fixedPhrase19", "fixedPhraseTitle20", "fixedPhrase20"
            ]
        };
    },

    watch: {
        selectedNode: {
            handler(newVal, oldVal) {
                if (this.selectedNode.data.type == 2) {
                    return this.getInfo(this.selectedNode.data.settingId);
                }
            }
        }
    },

    created: function() {
        for (let category of this.fixedPhraseCategoryList) {
            this.fixedPhraseItem.category.push({ value: category.value, name: commonUtil.getMessageText(this.$i18n, category.messageId) });
        }
        for (let soundType of this.soundTypeList) {
            this.fixedPhraseItem.soundType.push({ value: soundType.value, name: commonUtil.getMessageText(this.$i18n, soundType.messageId) });
        }
        if (this.selectedNode.data.type == 2) {
            return this.getInfo(this.selectedNode.data.settingId);
        }
    },

    methods: {
        getInfo(settingId) {
            this.clientSettingInfo = [];
            let self = this;
            server.post('/getenforceclientsettings',
                    {
                        templateId: settingId
                    })
            .then((res) => {
                switch(res.data.status) {
                    case 0:
                        self.showClientSetting = false;
                        self.clientSettingInfo = JSON.parse(res.data.template.settingJson);
                        if (typeof self.clientSettingInfo.Chat == "undefined") {
                            self.clientSettingInfo.Chat = {};
                        }
                        if (typeof self.clientSettingInfo.Video == "undefined") {
                            self.clientSettingInfo.Video = {};
                        }
                        for (let item in self.currentSetting) {
                            let categorySetting = self.clientSettingInfo[self.currentSetting[item].category]
                            if ((item.indexOf("fixedPhrase") === 0) && ((item.indexOf("fixedPhraseTitle") < 0))) {
                                if (categorySetting[item] === undefined) {
                                    categorySetting[item] = null;
                                } else {
                                    self.currentSetting[item].value = [];
                                    let index = 1;
                                    for (let fixedPhrase of categorySetting[item]) {
                                        if (fixedPhrase.indexOf("SOUND:") === 0) {
                                            self.currentSetting[item].value.push({orderNumber: index, categoryValue: constants.FIXED_PHRASE_CATEGORY_SOUND, phraseValue: Number(fixedPhrase.substring(6))});
                                        } else if (fixedPhrase.indexOf("MML:") === 0) {
                                            self.currentSetting[item].value.push({orderNumber: index, categoryValue: constants.FIXED_PHRASE_CATEGORY_MELODY, phraseValue: fixedPhrase.substring(4)});
                                        } else {
                                            self.currentSetting[item].value.push({orderNumber: index, categoryValue: constants.FIXED_PHRASE_CATEGORY_TEXT, phraseValue: fixedPhrase});
                                        }
                                        index++;
                                    }
                                    self.clientSettingInfo.Common[item] = self.currentSetting[item].value;
                                }
                            } else {
                                self.currentSetting[item].value = categorySetting[item] == undefined ? null : categorySetting[item];
                            }
                            self.currentSetting[item].enabled = categorySetting[item] == undefined ? false : true;
                        }
                        self.$nextTick(() => {
                            self.showClientSetting = true;
                        });
                        break;
                    case -15:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_should_purchase_client_setting_option"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getInfo").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getInfo", error);
            });
        },

        addSetting() {
            if (!this.appData.tenantAdminUser) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_need_tenant_admin_privilege"));
                return;
            }

            let self = this;
            let templateSettingName = commonUtil.getMessageText(self.$i18n,"item_client_default_setting");
            server.post('/createenforceclientsettings',
                    {
                        templateName: templateSettingName,
                        settingJson: JSON.stringify(this.defaultSetting)
                    })
            .then((res) => {
                switch (res.data.status) {
                    case -0:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_client_setting_added"));
                        var insertData = { data :
                                            {
                                                settingId: res.data.templateId,
                                                settingName: templateSettingName,
                                                label: templateSettingName,
                                                type: 2,
                                                isLeaf: true
                                             }
                                         };
                        self.insertNewClientSettingToTree(insertData , self.selectedNode);
                        break;
                    case -15:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_should_purchase_client_setting_option"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","addSetting").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "addSetting", error);
            });
        },

        modifyClientSetting(input) {
            this.showEditClientSetting = false;
            let self = this;
            server.post('/modifyenforceclientsettings',
                    {
                        templateId: this.selectedNode.data.settingId,
                        newTemplateName: input.settingName,
                        newSettingJson: JSON.stringify(input.settingJson)
                    })
            .then((res) => {
                switch (res.data.status) {
                    case -0:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_client_setting_modified"))
                        if (self.selectedNode.data.settingName == input.settingName) {
                            self.getInfo(this.selectedNode.data.settingId);
                        } else {
                            var insertData = { data :
                                                {
                                                    settingId: this.selectedNode.data.settingId,
                                                    settingName: input.settingName,
                                                    label: input.settingName,
                                                    type: 2,
                                                    isLeaf: true
                                                 }
                                             };
                            self.insertNewClientSettingToTree(insertData, self.selectedNode.parent);
                            self.selectedNode.parent.removeChild(self.selectedNode);
                        }
                        break;
                    case -15:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_should_purchase_client_setting_option"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","modifyClientSetting").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "modifyClientSetting", error);
            });
        },

        confirmDeleteClientSetting() {
            this.confirmInfo.objectTitle = commonUtil.getMessageText(self.$i18n,"title_client_setting");
            this.confirmInfo.objectName = this.selectedNode.data.settingName;
            this.showDeleteClientSetting = true;
        },

        deleteCientSetting() {
            this.showDeleteClientSetting = false;
            let self = this;
            server.post(
                '/deleteenforceclientsettings', {
                        settingId: this.selectedNode.data.settingId
                })
            .then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_client_setting_deleted"));
                    let parentNode = self.selectedNode.parent;
                    parentNode.removeChild(self.selectedNode);
                    self.selectedNode = parentNode;
                } else {
                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","deleteCientSetting").replace("{code}",res.data.status));
                }
            })
        },

        insertNewClientSettingToTree(insertData, parentNode) {
            if (parentNode.childNodes.length == 0) {
                parentNode.insertChild(insertData,0);
                parentNode.isLeaf = false;
                this.$emit('reloadTree');
            } else {

                var insertIndex = this.getInsertIndexOfNode(parentNode , insertData.data.settingName);

                if (insertIndex < 0) {
                    parentNode.insertBefore(insertData,parentNode.childNodes[0]);
                } else {
                    parentNode.insertAfter(insertData,parentNode.childNodes[insertIndex]);
                }

            }

            if ((!parentNode.isLeaf) && (!parentNode.loaded)) {
                parentNode.expand(() => {
                    parentNode.loaded = true;
                });
            } else {
                parentNode.expand();
            }

            this.$emit('setCurrentNode',insertData.data.settingId);
        },

        getInsertIndexOfNode: function(parentNode , insertObjectName) {
            let insertIndex = -1;
            for (let i = 0 ; i < parentNode.childNodes.length ; i++) {
                if (commonUtil.compareStringWithNumber(parentNode.childNodes[i].data.label, insertObjectName) < 0) {
                    insertIndex = i;
                } else {
                    break;
                }
            }
            return insertIndex;
        },

        getEnforcingSettingValue(setting) {
            if (setting == undefined) {
                return "-";
            } else {
                return setting;
            }
        },

        handleChangeEnabled(settingName) {
            if (this.currentSetting[settingName].enabled) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_enable_client_setting"));
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_disable_client_setting"));
            }
            this.currentSetting[settingName].enabled = !this.currentSetting[settingName].enabled;
        },

        checkBrowserToShowEditClientSetting() {
            if (!this.appData.tenantAdminUser) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_need_tenant_admin_privilege"));
                return;
            }

            var userAgent = window.navigator.userAgent.toLowerCase();
            if ((userAgent.indexOf('msie') != -1) ||
                (userAgent.indexOf('trident') != -1)) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_browser"));
                return;
            }
            this.showEditClientSetting = true;
        },

        reDrawClientSetting() {
            // some of before setting parameter remained after reload setting.
            // it can clear by redraw
            this.showClientSetting = false;
            this.$nextTick(() => {
                 this.showClientSetting = true
            })
        },
    }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-slider {
  /* width: 250px !important; */
  padding-left:10px;
  padding-right:20px
}

.setting-item-record {
    border-bottom: 1px solid #eee;
}
.setting-switch {
    text-align: right;
    padding-right: 20px;
}
.setting-switch-header {
    text-align: right;
    padding-right: 20px;
    color: #848991;
    font-size: 12px;
}
</style>
